import { useQuery } from "@tanstack/react-query";

import type { CreatedTemplate } from "features/templates/types";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

async function getTemplates(workspaceId: string) {
  return (await get(`workspaces/${workspaceId}/templates`)).templates;
}

export default function useTemplates() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { templatesKeys } = getQueryKeys(workspaceId);

  const {
    isLoading: isLoadingAllTemplates,
    data: allTemplates,
    error: templatesError,
    refetch: refetchTemplates,
  } = useQuery<CreatedTemplate[]>({
    queryKey: templatesKeys.list,
    queryFn: () => getTemplates(workspaceId),
  });

  return {
    allTemplates,
    isLoadingAllTemplates,
    templatesError,
    refetchTemplates,
  };
}
